<template>
    <ResetResult />
</template>

<script>
import ResetResult from "@/components/ResetResult.vue";

export default {
    name: 'ResetResultView',
    components: {
        ResetResult
    }
}
</script>
